// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.dialog[data-v-f233e398] .header {
  padding: 10px 12px 10px 12px;
}
.dialog[data-v-f233e398] .header .close-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  position: relative;
  margin-left: -36px;
}
.dialog[data-v-f233e398] .header .close-btn i {
  font-size: 16px;
}
.dialog[data-v-f233e398] .header .close-btn:hover {
  border-radius: 50%;
  background-color: var(--chat-item-right-block-bg);
}
.dialog[data-v-f233e398] .header .custom-header {
  position: relative;
  display: flex;
  align-items: center;
  width: 100%;
  height: 100%;
}
.dialog[data-v-f233e398] .header .custom-header .contact-info {
  display: flex;
  flex-direction: column;
  margin-left: 0.9em;
  justify-content: center;
}
.dialog[data-v-f233e398] .header .custom-header .contact-info .contact-name {
  font-size: 18px;
  line-height: 1.5em;
}
.dialog[data-v-f233e398] .header .custom-header .contact-info .contact-status {
  color: var(--message-grey-color);
  line-height: 1.25em;
}
.dialog[data-v-f233e398] .header .custom-header .call-btn {
  cursor: pointer;
  margin-right: 40px;
}
.dialog[data-v-f233e398] .header .custom-header .call-btn i {
  padding-right: 2px;
}
.dialog[data-v-f233e398] .header .custom-header .main-btn {
  margin-left: auto;
  margin-right: 2em;
}
.dialog[data-v-f233e398] .body {
  display: flex;
  flex-direction: column;
  height: auto;
  overflow-x: hidden;
  border-top: solid 1px var(--border-top-input);
  border-bottom: solid 1px var(--border-top-input);
  transition: all 0.5s;
}
.dialog[data-v-f233e398] .footer {
  padding: 10px 8px;
}
.dialog .chat[data-v-f233e398] {
  scroll-behavior: smooth;
  padding-bottom: 8px;
}
.dialog .chat .chat-space[data-v-f233e398] {
  min-height: 100px;
}
.dialog .chat .chat-msg-wrapper[data-v-f233e398] {
  display: flex;
  flex-direction: column;
  width: 100%;
}
.dialog .chat .chat-msg-wrapper .messages-move[data-v-f233e398] {
  transition: transform 1s;
}
.dialog .chat .chat-msg-wrapper .chat-date[data-v-f233e398] {
  align-self: center;
  background-color: var(--message-system-bgcolor);
  color: var(--chat-system-color);
  padding: 3px 8px;
  margin-top: 16px;
  margin-bottom: 4px;
  border-radius: 17px;
  font-size: 12px;
}
.dialog .chat .chat-msg-wrapper .chat-msg[data-v-f233e398] {
  position: relative;
  width: 100%;
}
.dialog .chat .chat-msg-wrapper .chat-msg .icon[data-v-f233e398] {
  position: absolute;
  left: -38px;
  bottom: 0px;
}
.dialog .chat .chat-msg-wrapper .chat-msg .msg[data-v-f233e398] {
  position: relative;
  display: flex;
  flex-direction: column;
  border-radius: 10px;
  padding: 4px 6px;
  min-width: 78px;
}
.dialog .chat .chat-msg-wrapper .chat-msg .msg .text[data-v-f233e398] {
  align-self: flex-start;
  white-space: pre-wrap;
  justify-content: left;
  word-break: break-word;
}
.dialog .chat .chat-msg-wrapper .chat-msg .msg .time[data-v-f233e398] {
  align-self: flex-end;
}
.dialog .chat .chat-msg-wrapper .chat-msg .msg.not-sent[data-v-f233e398] {
  filter: brightness(0.95);
  color: var(--tetra-msg-notsent-color);
  background-color: var(--tetra-msg-notsent-bgcolor) !important;
}
.dialog .chat .chat-msg-wrapper .chat-msg .msg.not-sent[data-v-f233e398]::after {
  border-bottom-color: var(--tetra-msg-notsent-bgcolor) !important;
}
.dialog .chat .chat-msg-wrapper .chat-msg .msg[data-v-f233e398]::after {
  content: '';
  position: absolute;
  width: 0;
  height: 0;
  border-bottom: 12px solid var(--message-left-bgcolor);
  border-left: 14px solid transparent;
  border-right: 12px solid transparent;
  transform: translate(100%, 100%);
}
.dialog .chat .chat-msg-wrapper .chat-msg .time[data-v-f233e398] {
  font-size: 0.8em;
  color: var(--message-grey-color);
  z-index: 1;
}
.dialog .chat .chat-msg-wrapper .chat-msg.in[data-v-f233e398] {
  display: flex;
  align-self: start;
  justify-content: start;
  max-width: 70%;
  margin: 1px;
}
.dialog .chat .chat-msg-wrapper .chat-msg.in .msg[data-v-f233e398] {
  background-color: var(--message-left-bgcolor);
}
.dialog .chat .chat-msg-wrapper .chat-msg.in .msg[data-v-f233e398]::after {
  left: -36px;
  bottom: 12px;
}
.dialog .chat .chat-msg-wrapper .chat-msg.out[data-v-f233e398] {
  display: flex;
  align-self: end;
  justify-content: end;
  max-width: 70%;
  margin: 1px;
}
.dialog .chat .chat-msg-wrapper .chat-msg.out .msg[data-v-f233e398] {
  background: var(--message-right-bgcolor);
}
.dialog .chat .chat-msg-wrapper .chat-msg.out .msg[data-v-f233e398]::after {
  right: 18px;
  bottom: 12px;
  border-bottom: 12px solid var(--message-right-bgcolor);
  border-left: 14px solid transparent;
  border-right: 12px solid transparent;
}
.dialog .enter-message-area[data-v-f233e398] {
  display: flex;
  max-height: 120px;
  width: 100%;
  border: solid 1px var(--border-top-input);
}
.dialog .enter-message-area .custom-textarea[data-v-f233e398] {
  position: relative;
  padding: 10px 8px;
}
.dialog .enter-message-area .custom-textarea[data-v-f233e398] .custom-textarea {
  overflow-y: auto;
}
.dialog .enter-message-area .buttons[data-v-f233e398] {
  pointer-events: all;
}
.dialog .enter-message-area .buttons[data-v-f233e398].circle-animation i {
  color: var(--toolbtn-active-color);
  font-size: 1.3em;
}
.dialog .enter-message-area .buttons.disable-btn[data-v-f233e398] {
  pointer-events: none;
  cursor: initial;
}
.dialog .enter-message-area .buttons.disable-btn i[data-v-f233e398] {
  color: var(--elem-grey-color);
}
.dialog .enter-message-area .buttons.disable-btn[data-v-f233e398]:hover {
  cursor: initial;
}
.dialog .enter-message-area .buttons.disable-btn[data-v-f233e398]:active::after {
  content: none;
}
.dialog .message-overflow[data-v-f233e398] {
  position: absolute;
  margin-top: -4em;
  margin-left: 4em;
  width: 340px;
}
.dialog .message-overflow .message-overflow-alert[data-v-f233e398] {
  display: flex;
  flex-direction: row;
  width: auto;
  margin: auto 10px 10px 10px;
  padding: 10px;
  height: 40px;
  line-height: 20px;
  border-radius: 5px;
  border: solid 1px #ff4747;
  color: #ebebeb;
  background-color: #bd3636de;
}
.dialog .message-overflow .message-overflow-alert span[data-v-f233e398] {
  align-self: flex-start;
}
.dialog .message-overflow .message-overflow-alert div[data-v-f233e398] {
  align-self: flex-end;
  margin: auto 0px auto auto;
  cursor: pointer;
}
.dialog .message-overflow .fade-enter-active[data-v-f233e398],
.dialog .message-overflow .fade-leave-active[data-v-f233e398] {
  transition: opacity .25s;
}
.dialog .message-overflow .fade-enter[data-v-f233e398],
.dialog .message-overflow .fade-leave-to[data-v-f233e398] {
  opacity: 0;
}
.dialog .last-msg-animation[data-v-f233e398] {
  animation-name: last-msg-f233e398;
  animation-duration: 0.5s;
}
@keyframes last-msg-f233e398 {
0% {
    transform: scale(0, 0);
}
50% {
    transform: scale(1, 0.025);
}
}
`, "",{"version":3,"sources":["webpack://./js/app/components/radio/TetraChat.vue"],"names":[],"mappings":"AAAA;EACE,4BAA4B;AAC9B;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;AACpB;AACA;EACE,eAAe;AACjB;AACA;EACE,kBAAkB;EAClB,iDAAiD;AACnD;AACA;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,YAAY;AACd;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,kBAAkB;EAClB,uBAAuB;AACzB;AACA;EACE,eAAe;EACf,kBAAkB;AACpB;AACA;EACE,gCAAgC;EAChC,mBAAmB;AACrB;AACA;EACE,eAAe;EACf,kBAAkB;AACpB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,iBAAiB;EACjB,iBAAiB;AACnB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,kBAAkB;EAClB,6CAA6C;EAC7C,gDAAgD;EAChD,oBAAoB;AACtB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,uBAAuB;EACvB,mBAAmB;AACrB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,kBAAkB;EAClB,+CAA+C;EAC/C,+BAA+B;EAC/B,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;AACjB;AACA;EACE,kBAAkB;EAClB,WAAW;AACb;AACA;EACE,kBAAkB;EAClB,WAAW;EACX,WAAW;AACb;AACA;EACE,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;AACjB;AACA;EACE,sBAAsB;EACtB,qBAAqB;EACrB,qBAAqB;EACrB,sBAAsB;AACxB;AACA;EACE,oBAAoB;AACtB;AACA;EACE,wBAAwB;EACxB,qCAAqC;EACrC,6DAA6D;AAC/D;AACA;EACE,gEAAgE;AAClE;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,qDAAqD;EACrD,mCAAmC;EACnC,oCAAoC;EACpC,gCAAgC;AAClC;AACA;EACE,gBAAgB;EAChB,gCAAgC;EAChC,UAAU;AACZ;AACA;EACE,aAAa;EACb,iBAAiB;EACjB,sBAAsB;EACtB,cAAc;EACd,WAAW;AACb;AACA;EACE,6CAA6C;AAC/C;AACA;EACE,WAAW;EACX,YAAY;AACd;AACA;EACE,aAAa;EACb,eAAe;EACf,oBAAoB;EACpB,cAAc;EACd,WAAW;AACb;AACA;EACE,wCAAwC;AAC1C;AACA;EACE,WAAW;EACX,YAAY;EACZ,sDAAsD;EACtD,mCAAmC;EACnC,oCAAoC;AACtC;AACA;EACE,aAAa;EACb,iBAAiB;EACjB,WAAW;EACX,yCAAyC;AAC3C;AACA;EACE,kBAAkB;EAClB,iBAAiB;AACnB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,kCAAkC;EAClC,gBAAgB;AAClB;AACA;EACE,oBAAoB;EACpB,eAAe;AACjB;AACA;EACE,6BAA6B;AAC/B;AACA;EACE,eAAe;AACjB;AACA;EACE,aAAa;AACf;AACA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,YAAY;AACd;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,2BAA2B;EAC3B,aAAa;EACb,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,yBAAyB;EACzB,cAAc;EACd,2BAA2B;AAC7B;AACA;EACE,sBAAsB;AACxB;AACA;EACE,oBAAoB;EACpB,0BAA0B;EAC1B,eAAe;AACjB;AACA;;EAEE,wBAAwB;AAC1B;AACA;;EAEE,UAAU;AACZ;AACA;EACE,iCAAiC;EACjC,wBAAwB;AAC1B;AACA;AACA;IACI,sBAAsB;AAC1B;AACA;IACI,0BAA0B;AAC9B;AACA","sourcesContent":[".dialog[data-v-f233e398] .header {\n  padding: 10px 12px 10px 12px;\n}\n.dialog[data-v-f233e398] .header .close-btn {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 32px;\n  height: 32px;\n  position: relative;\n  margin-left: -36px;\n}\n.dialog[data-v-f233e398] .header .close-btn i {\n  font-size: 16px;\n}\n.dialog[data-v-f233e398] .header .close-btn:hover {\n  border-radius: 50%;\n  background-color: var(--chat-item-right-block-bg);\n}\n.dialog[data-v-f233e398] .header .custom-header {\n  position: relative;\n  display: flex;\n  align-items: center;\n  width: 100%;\n  height: 100%;\n}\n.dialog[data-v-f233e398] .header .custom-header .contact-info {\n  display: flex;\n  flex-direction: column;\n  margin-left: 0.9em;\n  justify-content: center;\n}\n.dialog[data-v-f233e398] .header .custom-header .contact-info .contact-name {\n  font-size: 18px;\n  line-height: 1.5em;\n}\n.dialog[data-v-f233e398] .header .custom-header .contact-info .contact-status {\n  color: var(--message-grey-color);\n  line-height: 1.25em;\n}\n.dialog[data-v-f233e398] .header .custom-header .call-btn {\n  cursor: pointer;\n  margin-right: 40px;\n}\n.dialog[data-v-f233e398] .header .custom-header .call-btn i {\n  padding-right: 2px;\n}\n.dialog[data-v-f233e398] .header .custom-header .main-btn {\n  margin-left: auto;\n  margin-right: 2em;\n}\n.dialog[data-v-f233e398] .body {\n  display: flex;\n  flex-direction: column;\n  height: auto;\n  overflow-x: hidden;\n  border-top: solid 1px var(--border-top-input);\n  border-bottom: solid 1px var(--border-top-input);\n  transition: all 0.5s;\n}\n.dialog[data-v-f233e398] .footer {\n  padding: 10px 8px;\n}\n.dialog .chat[data-v-f233e398] {\n  scroll-behavior: smooth;\n  padding-bottom: 8px;\n}\n.dialog .chat .chat-space[data-v-f233e398] {\n  min-height: 100px;\n}\n.dialog .chat .chat-msg-wrapper[data-v-f233e398] {\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n}\n.dialog .chat .chat-msg-wrapper .messages-move[data-v-f233e398] {\n  transition: transform 1s;\n}\n.dialog .chat .chat-msg-wrapper .chat-date[data-v-f233e398] {\n  align-self: center;\n  background-color: var(--message-system-bgcolor);\n  color: var(--chat-system-color);\n  padding: 3px 8px;\n  margin-top: 16px;\n  margin-bottom: 4px;\n  border-radius: 17px;\n  font-size: 12px;\n}\n.dialog .chat .chat-msg-wrapper .chat-msg[data-v-f233e398] {\n  position: relative;\n  width: 100%;\n}\n.dialog .chat .chat-msg-wrapper .chat-msg .icon[data-v-f233e398] {\n  position: absolute;\n  left: -38px;\n  bottom: 0px;\n}\n.dialog .chat .chat-msg-wrapper .chat-msg .msg[data-v-f233e398] {\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  border-radius: 10px;\n  padding: 4px 6px;\n  min-width: 78px;\n}\n.dialog .chat .chat-msg-wrapper .chat-msg .msg .text[data-v-f233e398] {\n  align-self: flex-start;\n  white-space: pre-wrap;\n  justify-content: left;\n  word-break: break-word;\n}\n.dialog .chat .chat-msg-wrapper .chat-msg .msg .time[data-v-f233e398] {\n  align-self: flex-end;\n}\n.dialog .chat .chat-msg-wrapper .chat-msg .msg.not-sent[data-v-f233e398] {\n  filter: brightness(0.95);\n  color: var(--tetra-msg-notsent-color);\n  background-color: var(--tetra-msg-notsent-bgcolor) !important;\n}\n.dialog .chat .chat-msg-wrapper .chat-msg .msg.not-sent[data-v-f233e398]::after {\n  border-bottom-color: var(--tetra-msg-notsent-bgcolor) !important;\n}\n.dialog .chat .chat-msg-wrapper .chat-msg .msg[data-v-f233e398]::after {\n  content: '';\n  position: absolute;\n  width: 0;\n  height: 0;\n  border-bottom: 12px solid var(--message-left-bgcolor);\n  border-left: 14px solid transparent;\n  border-right: 12px solid transparent;\n  transform: translate(100%, 100%);\n}\n.dialog .chat .chat-msg-wrapper .chat-msg .time[data-v-f233e398] {\n  font-size: 0.8em;\n  color: var(--message-grey-color);\n  z-index: 1;\n}\n.dialog .chat .chat-msg-wrapper .chat-msg.in[data-v-f233e398] {\n  display: flex;\n  align-self: start;\n  justify-content: start;\n  max-width: 70%;\n  margin: 1px;\n}\n.dialog .chat .chat-msg-wrapper .chat-msg.in .msg[data-v-f233e398] {\n  background-color: var(--message-left-bgcolor);\n}\n.dialog .chat .chat-msg-wrapper .chat-msg.in .msg[data-v-f233e398]::after {\n  left: -36px;\n  bottom: 12px;\n}\n.dialog .chat .chat-msg-wrapper .chat-msg.out[data-v-f233e398] {\n  display: flex;\n  align-self: end;\n  justify-content: end;\n  max-width: 70%;\n  margin: 1px;\n}\n.dialog .chat .chat-msg-wrapper .chat-msg.out .msg[data-v-f233e398] {\n  background: var(--message-right-bgcolor);\n}\n.dialog .chat .chat-msg-wrapper .chat-msg.out .msg[data-v-f233e398]::after {\n  right: 18px;\n  bottom: 12px;\n  border-bottom: 12px solid var(--message-right-bgcolor);\n  border-left: 14px solid transparent;\n  border-right: 12px solid transparent;\n}\n.dialog .enter-message-area[data-v-f233e398] {\n  display: flex;\n  max-height: 120px;\n  width: 100%;\n  border: solid 1px var(--border-top-input);\n}\n.dialog .enter-message-area .custom-textarea[data-v-f233e398] {\n  position: relative;\n  padding: 10px 8px;\n}\n.dialog .enter-message-area .custom-textarea[data-v-f233e398] .custom-textarea {\n  overflow-y: auto;\n}\n.dialog .enter-message-area .buttons[data-v-f233e398] {\n  pointer-events: all;\n}\n.dialog .enter-message-area .buttons[data-v-f233e398].circle-animation i {\n  color: var(--toolbtn-active-color);\n  font-size: 1.3em;\n}\n.dialog .enter-message-area .buttons.disable-btn[data-v-f233e398] {\n  pointer-events: none;\n  cursor: initial;\n}\n.dialog .enter-message-area .buttons.disable-btn i[data-v-f233e398] {\n  color: var(--elem-grey-color);\n}\n.dialog .enter-message-area .buttons.disable-btn[data-v-f233e398]:hover {\n  cursor: initial;\n}\n.dialog .enter-message-area .buttons.disable-btn[data-v-f233e398]:active::after {\n  content: none;\n}\n.dialog .message-overflow[data-v-f233e398] {\n  position: absolute;\n  margin-top: -4em;\n  margin-left: 4em;\n  width: 340px;\n}\n.dialog .message-overflow .message-overflow-alert[data-v-f233e398] {\n  display: flex;\n  flex-direction: row;\n  width: auto;\n  margin: auto 10px 10px 10px;\n  padding: 10px;\n  height: 40px;\n  line-height: 20px;\n  border-radius: 5px;\n  border: solid 1px #ff4747;\n  color: #ebebeb;\n  background-color: #bd3636de;\n}\n.dialog .message-overflow .message-overflow-alert span[data-v-f233e398] {\n  align-self: flex-start;\n}\n.dialog .message-overflow .message-overflow-alert div[data-v-f233e398] {\n  align-self: flex-end;\n  margin: auto 0px auto auto;\n  cursor: pointer;\n}\n.dialog .message-overflow .fade-enter-active[data-v-f233e398],\n.dialog .message-overflow .fade-leave-active[data-v-f233e398] {\n  transition: opacity .25s;\n}\n.dialog .message-overflow .fade-enter[data-v-f233e398],\n.dialog .message-overflow .fade-leave-to[data-v-f233e398] {\n  opacity: 0;\n}\n.dialog .last-msg-animation[data-v-f233e398] {\n  animation-name: last-msg-f233e398;\n  animation-duration: 0.5s;\n}\n@keyframes last-msg-f233e398 {\n0% {\n    transform: scale(0, 0);\n}\n50% {\n    transform: scale(1, 0.025);\n}\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
